import { useFlags as useLDFlags } from 'launchdarkly-react-client-sdk';
import { AnalyticsFeatureFlags } from '../analytics';
import { getFeatureFlagsOverride } from '../utils';

// override flags for development until launchdarkly supports this
// https://github.com/launchdarkly/react-client-sdk/issues/53
export function useFlags<Flags extends AnalyticsFeatureFlags>(devOverride: Flags = {} as Flags): Flags {
	const ldFlags = useLDFlags();

	return { ...ldFlags, ...getFeatureFlagsOverride(ldFlags), ...devOverride } as Flags;
}
